<template>
  <div>
    <header-vue></header-vue>
    <div style="height: 40px"></div>
    <router-view></router-view>
    <FooterVue></FooterVue>
  </div>
</template>

<script>
import HeaderVue from "../components/Header.vue";
import FooterVue from "../components/FFooter.vue";
export default {
  components: { HeaderVue, FooterVue },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
</style>